import { render, staticRenderFns } from "./AssociarDocumentos.vue?vue&type=template&id=88508b14"
import script from "./AssociarDocumentos.vue?vue&type=script&lang=js"
export * from "./AssociarDocumentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports